export const setToken = (token: string): void => {
  localStorage.setItem("token", token);
};

export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

export const removeToken = (): void => {
  localStorage.removeItem("token");
};

export const setUserInfo = (userInfo: any): void => {
  localStorage.setItem("userInfo", JSON.stringify(userInfo));
};

export const getUserInfo = (): any => {
  return localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo") || "")
    : null;
};

export const removeUserInfo = (): void => {
  localStorage.removeItem("userInfo");
};
